import {
  Spacing
} from 'UI'

export default theme => ({
  projectSection: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: ({ margin }) => margin,
    padding: ({ componentPadding }) => componentPadding
  },
  paperClass: {
    display: 'flex',
    flexDirection: 'column',
    padding: ({ padding }) => padding
  },
  image: {
    cursor: 'pointer',
    borderRadius: 4
  },
  projectPictures: {
    display: 'flex',
    flexDirection: 'row',
    gap: 12,
    overflow: 'hidden'
  },
  view: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center'
  },
  cardStyle: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  overlay: {
    height: 69,
    width: '100%',
    position: 'absolute',
    opacity: 0,
    cursor: 'pointer',
    backgroundColor: 'rgba(55,103,218,0.67)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.3s ease-in-out'
  },
  iconStyle: {
    color: theme.neutral[400],
    fontSize: 16
  },
  overlayContainer: {
    position: 'relative',
    '&:hover $overlay': {
      opacity: 1
    }
  },
  responsiveRow: {
    overflow: 'auto',
    flexWrap: 'nowrap !important',
    marginRight: '-15px !important'
  },
  responsiveCard: {
    margin: () => Spacing(0, 2, 0, 0)
  }
})
